const isValidEmail = (email) => {
  // Simple regex for email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const trackLogin = async (email) => {

   // Validate the email before making the POST request
  if (!isValidEmail(email)) {
    // console.log(email)
    console.error('Invalid email format');
    return;
  }

  // const API_KEY = process.env.REACT_APP_API_KEY; // Stored in your .env file
  const API_KEY = 'troepEllendeADFhjFD@((@';
  try {
    const response = await fetch('https://marijnnijenhuis.nl/whatthedof/login.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Auth': `code ${API_KEY}`
      },
      body: new URLSearchParams({
        'email': email
      })
    });

    if (response.ok) {
      console.log('Login OK.');
      // console.log(response);
    } else {
      console.error('Login problem 1.');
      // console.log(response)
    }
  } catch (error) {
    // console.error('Network error:', error);
    console.log('Login problem 2.');
  }
};